import { Icon } from "@iconify/react";
import { Button, Spin, Typography, message } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import ConfirmationModal from "~/Components/Modal/confirmation-modal";
import { api, magpCMSApi } from "~/Services";

export const NewTab = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<any>([]);
  const [isModalopen, setIsModalopen] = useState(false);
  const [deleteId, setDeleteId] = useState<string | null>(null);

  const getRecords = () => {
    setIsLoading(true);
    let url = `/api/get-contact-directory-departments/all-fields`;
    magpCMSApi
      .get(url)
      .then((res: any) => {
        if (res && res.data) {
          let tabslist = res.data;
          setData(tabslist);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getRecords();
  }, []);

  return (
    <>
      <ContentWrapper
        customTitle={
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Icon
              icon="material-symbols:arrow-back"
              width="28"
              height="28"
              className="cursor-pointer"
              onClick={() => navigate(-1)}
            />
            <Typography.Title
              level={3}
              style={{ margin: 0 }}
            >
              Contact Directory Tabs
            </Typography.Title>
          </div>
        }
      >
        <>
          <div style={{ height: "100%", position: "relative" }}>
            {isLoading ? (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Spin size="large" />
              </div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                {data.map((item: any, index: any) => (
                  <div
                    key={item.id}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "16px",
                      borderRadius: "12px",
                      background: "#f5f5f7",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                      <div
                        style={{
                          background: "#e6e6fa",
                          borderRadius: "50%",
                          width: "32px",
                          height: "32px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: 600,
                        }}
                      >
                        {index + 1}
                      </div>
                      <Typography.Text strong>{item.name}</Typography.Text>
                    </div>

                    <div style={{ display: "flex", gap: "12px" }}>
                      <Button onClick={() => navigate(`/dedicated/magp/contact-directory/add?cdId=${item.id}`)}>
                        Edit
                      </Button>
                      <Button
                        danger
                        onClick={() => {
                          setDeleteId(item.id);
                          setIsModalopen(true);
                        }}
                      >
                        Delete
                      </Button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </>
      </ContentWrapper>
      <ConfirmationModal
        open={isModalopen}
        type="delete"
        confirmationText="Are you sure you want to delete the Contact Directory tab and its details?"
        onClose={() => {
          setIsModalopen(false);
          setDeleteId(null);
        }}
        onSubmit={async (reviewNotes?: string) => {
          if (deleteId) {
            try {
              setIsLoading(true);
              const selectedItem = data.find((item: any) => item.id === deleteId);
              const payload = {
                action: "DELETE",
                method: "DELETE",
                module: "Contact Directory",
                subModule: "addcontactdirectory",
                type: "DEDICATED",
                application: "MAGP",
                reviewNotes: reviewNotes,
                appList: [
                  {
                    appName: "MAGP",
                    apiUrl: `https://apim-magb.azure-api.net/magpcmsnp/api/contactdirectorydepartment/${deleteId}`,
                  },
                ],
                payload: {
                  ...selectedItem,
                },
                status: "PENDING",
              };
              await api.post("/management/publish", payload);

              message.success("Delete request submitted successfully");

              setIsModalopen(false);
              setDeleteId(null);

              navigate("/dedicated/status-information?activeTab=pending");
            } catch (err) {
              console.error(err);
              message.error("Failed to submit delete request");
            } finally {
              setIsLoading(false);
            }
          }
        }}
      />
    </>
  );
};
